// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import { useLoading } from 'context/loading.context';

import Icon from "@mui/material/Icon";
import MDSnackbar from "components/MDSnackbar";
// import EditIcon from '@mui/icons-material/Edit';
// import LinearProgress from '@mui/material/LinearProgress';
// import Checkbox from '@mui/material/Checkbox';
import FormControl from "@mui/material/FormControl";
import { ArrowDropDown } from "@mui/icons-material";
import { Select, MenuItem, InputLabel } from "@mui/material";
import Input from '@mui/material/Input';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Autocomplete from '@mui/material/Autocomplete';

import { useLocation, useNavigate } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import BoxRow from "./components/Box";
import ContactsTable from "./components/contacts";

import { useEffect, useState } from "react";

import moment from "moment";
import { getBranches, getContacts, getCarriers, getPackageType, getCountries, createUpdatePackage, getPackages, getBoxes, getPaymentModes, getReceivingAccounts, getEmployees, lookupPostal } from "network/service";
import Attachments from "./components/Attachments";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { shipmentWeights, shipmentValue } from "./weights";
import { wrapAddress, vendorAddressHint } from "./vendorAddress";
import { stateCountry, stateOptions, findStateOption } from "./stateCodes";
import { townNames, zipStateLabel, stateMismatch, cityMismatch, postalProblems, mapsSearchUrl } from "./postalCheck";
import { UOM_OPTIONS } from "./components/Items";
import { uploadFile } from "network/service";
import { API_ENDPOINT } from "network/service";

// Worldfirst's ExportReason master list — spelled EXACTLY as their portal shows
// it (including "COMMERICAL"), since the value is matched as text.
const EXPORT_REASONS = [
    "Bonafide Gift",
    "BUYER (IF OTHER THAN CONSIGNEE)",
    "FREE SAMPLE OF NO COMMERICAL VALUE",
    "GIFT",
    "Personal not for resale",
    "PERSONALEFFECTS",
    "SAMPLE",
    "Samples not for sale",
    "UNSOLICITED GIFT - NOT FOR SALE",
];
// Pre-selected on new shipments (and on older ones saved without a reason).
const DEFAULT_EXPORT_REASON = "UNSOLICITED GIFT - NOT FOR SALE";

function NewPackages() {
    const boxItemUomOptions = UOM_OPTIONS;

    const senderDocumentOptions = [
        { value: "aadhar", label: "Aadhar" },
        { value: "gstin", label: "GSTIN" },
        { value: "pan", label: "PAN" },
        { value: "iec", label: "IEC" }
    ];

    const getSenderDocumentType = (sender) => {
        if (sender?.document_type) return sender.document_type;
        if (sender?.aadhar) return "aadhar";
        if (sender?.iec) return "iec";
        return "aadhar";
    };

    const getSenderDocumentNumber = (sender) => sender?.aadhar || "";
    const getRefId = (value) => (value && typeof value === "object" ? (value._id || "") : (value || ""));
    const getSelectableEmployees = (allEmployees, selectedId) => {
        return (allEmployees || []).filter((employee) => employee.is_active || employee._id === selectedId);
    };

    const location = useLocation();
    const navigate = useNavigate();
    const [load, setLoading] = useState(false);
    const [branches, setBranches] = useState([]);
    const [contactList, setContacts] = useState([]);
    const [countries, setCountries] = useState([]);
    const [pickupType, setPickupType] = useState(0);
    const [selectedbranch, selectBranch] = useState(null);
    const [carriers, setCarriers] = useState([]);
    const [carrier, setCarrier] = useState(null);
    const [destination, setDestination] = useState(null);
    const [packageTypes, setPackageTypes] = useState([]);
    const [packageType, setPackageType] = useState(null);
    const [serviceDetails, setServiceDetails] = useState({ notes: "", weight: "", volumetric_weight: "", charge_weight: "", shipment_value: '', vendor_chargeable_weight: "", capex_chargeable_weight: "" });
    // Some vendors don't need a unit per item — staff can switch UOM off per shipment.
    const [uomRequired, setUomRequired] = useState(true);
    // Set when this form was opened via "Duplicate" on the packages list.
    const [duplicateOf, setDuplicateOf] = useState(null);
    // Sent with vendor bookings (Worldfirst/ICL). The reference is typed by
    // staff — branches use it to segregate their shipments in the vendor portal.
    const todayInput = () => moment().format("YYYY-MM-DD");
    const [bookingDetails, setBookingDetails] = useState({ reference_no: "", shipment_content: "", export_reason: DEFAULT_EXPORT_REASON, invoice_no: "", invoice_date: todayInput() });
    // Vendor booking of the shipment being edited (Vendor AWB + carrier AWB), shown at the top.
    const [vendorInfo, setVendorInfo] = useState(null);
    // Set when a save is refused for a blank Reference No — turns the field red.
    const [refMissing, setRefMissing] = useState(false);
    const [amounts, setAmounts] = useState({ courier_amount: '', other_amount: "0", total_amount: "", received_amount: "0", remaining_amount: "", receiving_account: "", mode: "", status: 0 });
    const [paymentModes, setPaymentModes] = useState([]);
    const [receivingAccounts, setReceivingAccounts] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [parcelWorkers, setParcelWorkers] = useState({ pickup_person: "", assigned_person: "" });
    const [contacts, setContactsPopup] = useState({ open: false, details: null });
    const [receiver, setReceiversPopup] = useState({ open: false, details: null });
    const [senderDetails, setSender] = useState({ id: null, company_name: "", name: "", lastname: "", title: "", address: "", state: "TAMILNADU", address2: "", address3: "", city: "", pincode: "", mobile: "", phone: "", email: "", country: { "_id": "6595a78c814e26a180b81855" }, iec: "", document: "aadhar", document_id: "" });
    const [receiverDetails, setReceiver] = useState({ id: null, company_name: "", name: "", lastname: "", title: "", address: "", state: "", address2: "", address3: "", city: "", pincode: "", mobile: "", phone: "", email: "", country: null, iec: "", document: "", document_id: "" });
    // "US" / "CA" / "AU" when the receiver's state must be picked from a list.
    const receiverStateCountry = stateCountry(receiverDetails.country, countries);

    // ZIP check (US / CA / AU): which state and town the receiver's ZIP is in.
    const [zipInfo, setZipInfo] = useState(null);
    useEffect(() => {
        const zip = String(receiverDetails.pincode || "").trim();
        if (!receiverStateCountry || !zip) {
            setZipInfo(null);
            return undefined;
        }
        let cancelled = false;
        const timer = setTimeout(() => {
            lookupPostal(receiverStateCountry, zip)
                .then((resp) => {
                    if (cancelled) return;
                    const info = { ...resp.data, typed: zip };
                    setZipInfo(info);
                    if (!info.found) return;
                    // Fill the state / town in when they're still empty.
                    setReceiver((prev) => {
                        if (String(prev.pincode || "").trim() !== zip) return prev;
                        const next = { ...prev };
                        if (!prev.state && info.states.length === 1) next.state = info.states[0].name;
                        if (!String(prev.city || "").trim() && info.city_check && info.places.length === 1) next.city = info.places[0].toUpperCase();
                        return next;
                    });
                })
                .catch(() => { if (!cancelled) setZipInfo(null); });
        }, 400);
        return () => { cancelled = true; clearTimeout(timer); };
    }, [receiverDetails.pincode, receiverStateCountry]);
    // Only trust the lookup for the ZIP currently in the field.
    const zipNow = zipInfo && zipInfo.typed === String(receiverDetails.pincode || "").trim() ? zipInfo : null;
    const zipHint = (() => {
        if (!receiverStateCountry || !zipNow || zipNow.available === false) return { text: "", error: false };
        if (!zipNow.format_ok) return { text: zipNow.hint, error: false };
        if (!zipNow.found) return { text: `Not found for ${receiverStateCountry} — check the ZIP`, error: true };
        const towns = townNames(zipNow);
        // Canada's data is per district, not per town.
        return { text: `${zipNow.city_check ? "" : "Area: "}${towns.slice(0, 3).join(", ")}${towns.length > 3 ? " …" : ""} — ${zipStateLabel(zipNow, receiverStateCountry)}`, error: false };
    })();
    const fixLink = (onUse) => (
        <span role="button" tabIndex={0} style={{ textDecoration: "underline", cursor: "pointer", fontWeight: 600 }}
            onClick={onUse} onKeyDown={(e) => { if (e.key === "Enter") onUse(); }}>use it</span>
    );
    const [file, setFiles] = useState([]);
    const [boxes, setBoxes] = useState([]);
    const [newBox, setNewBox] = useState({ length: "0", breadth: "0", width: "0", weight: "0", items: [], contains_medicine: false });
    const [notiDetails, setShowDetails] = useState({ show: false });
    const closeSB = () => setShowDetails({ ...notiDetails, show: false });
    const { loading, showLoader, hideLoader } = useLoading();
    const [calculatedValue, setCalculatedValue] = useState(0);


    const renderSB = (
        <MDSnackbar
            color={notiDetails.color}
            icon={notiDetails.icon}
            title={notiDetails.title}
            content={notiDetails.message}
            dateTime=""
            open={notiDetails.show}
            onClose={closeSB}
            close={closeSB}
            bgWhite
        />
    );

    // const data = [
    //     { name: 'Row 1', description: 'Description for Row 1', length: 0, breadth: 0, height: 0, weight: 0 },
    //     { name: 'Row 2', description: 'Description for Row 2', length: 0, breadth: 0, height: 0, weight: 0 },
    //     // Add more rows as needed
    // ];

    const validation = async () => {

        if (selectedbranch == null) {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Branch error", message: "Please select branch" });
            setLoading(false);
            return false;
        }

        if (senderDetails.name == "") {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Sender First Name Error", message: "Please enter sender first name" });
            setLoading(false);
            return false;
        }
        // if (senderDetails.lastname == "") {
        //     setShowDetails({ show: true, color: "error", icon: "warning", title: "Sender Last Name Error", message: "Please enter sender last name" });
        //     setLoading(false);
        //     return false;
        // }
        // if (senderDetails.title == "") {
        //     setShowDetails({ show: true, color: "error", icon: "warning", title: "Sender title Error", message: "Please select sender title" });
        //     setLoading(false);
        //     return false;
        // }

        if (senderDetails.address == "") {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Sender address Error", message: "Please enter sender address1" });
            setLoading(false);
            return false;
        }

        if (senderDetails.pincode == "") {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Sender pincode Error", message: "Please enter sender pincode" });
            setLoading(false);
            return false;
        }

        if (senderDetails.city == "") {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Sender city Error", message: "Please enter sender city" });
            setLoading(false);
            return false;
        }

        if (senderDetails.state == "") {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Sender state Error", message: "Please enter sender state" });
            setLoading(false);
            return false;
        }

        if (senderDetails.country == null) {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Sender Country Error", message: "Please select sender country  " });
            setLoading(false);
            return false;
        }

        if (senderDetails.mobile.length != 10 || senderDetails.mobile.length > 10) {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Sender mobile number Error", message: "Please enter valid mobile number " });
            setLoading(false);
            return false;
        }

        // if (senderDetails.document_id.length != 12 || senderDetails.document_id.length > 12) {
        //     setShowDetails({ show: true, color: "error", icon: "warning", title: "Sender aadhar number Error", message: "Please enter valid aadhar number " });
        //     setLoading(false);
        //     return false;
        // }

        if (receiverDetails.country == null) {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Destination error", message: "Please select destination" });
            setLoading(false);
            return false;
        }

        if (receiverDetails.name == "") {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Receiver Name Error", message: "Please enter receiver name" });
            setLoading(false);
            return false;
        }


        if (receiverDetails.address == "") {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Receiver address Error", message: "Please enter Receiver address1" });
            setLoading(false);
            return false;
        }

        if (receiverDetails.pincode == "") {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Receiver pincode Error", message: "Please enter Receiver pincode" });
            setLoading(false);
            return false;
        }

        if (receiverDetails.city == "") {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Receiver city Error", message: "Please enter receiver city" });
            setLoading(false);
            return false;
        }

        if (receiverDetails.state == "") {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Receiver state Error", message: "Please enter receiver state" });
            setLoading(false);
            return false;
        }
        if (receiverStateCountry && !findStateOption(receiverDetails.state, receiverStateCountry)) {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Receiver state Error", message: `"${receiverDetails.state}" isn't a valid ${receiverStateCountry} state — please pick the receiver state from the list` });
            setLoading(false);
            return false;
        }
        // ZIP check: does the ZIP belong to this state / town? Staff can still
        // save (a town can have more than one accepted name).
        if (receiverStateCountry && String(receiverDetails.pincode || "").trim()) {
            let info = null;
            try {
                info = (await lookupPostal(receiverStateCountry, receiverDetails.pincode.trim())).data;
            } catch (e) {
                info = null; // lookup unavailable — don't block the booking
            }
            const issues = postalProblems(info, receiverDetails, receiverStateCountry);
            // eslint-disable-next-line no-alert
            if (issues.length && !window.confirm(`Please check the receiver address:\n\n• ${issues.join("\n• ")}\n\nSave anyway?`)) {
                setLoading(false);
                return false;
            }
        }

        if (receiverDetails.country == null) {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Receiver Country Error", message: "Please select receiver country  " });
            setLoading(false);
            return false;
        }

        if (receiverDetails.mobile.length <= 0) {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Receiver mobile number Error", message: "Please enter valid mobile number " });
            setLoading(false);
            return false;
        }

        if (carrier == null) {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Carrier Error", message: "Please select carrier mode " });
            setLoading(false);
            return false;
        }
        if (packageType == null) {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Package Type Error", message: "Please select package type" });
            setLoading(false);
            return false;
        }
        // Mandatory: Worldfirst / ICL / Atlantic refuse a booking without it,
        // and branches use it to find their shipments in the vendor portal.
        if (!bookingDetails.reference_no.trim()) {
            setRefMissing(true);
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Reference No Error", message: "Please enter the Reference No (branch reference, e.g. WF141 - WM)" });
            setLoading(false);
            return false;
        }
        if (serviceDetails.weight == "") {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "actual weight Error", message: "Please enter actual weight type" });
            setLoading(false);
            return false;
        }

        if (amounts.courier_amount == "") {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Courier Amount Error", message: "Please enter courier amount" });
            setLoading(false);
            return false;
        }
        if (amounts.other_amount == "") {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Other Amount Error", message: "Please enter other amount" });
            setLoading(false);
            return false;
        }

        if (!amounts.mode) {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Payment Mode Error", message: "Please select payment mode" });
            setLoading(false);
            return false;
        }

        const totalAmountValue = parseFloat(amounts.total_amount || "0");
        const receivedAmountValue = parseFloat(amounts.received_amount || "0");
        if (isNaN(receivedAmountValue) || receivedAmountValue < 0) {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Received Amount Error", message: "Please enter valid received amount" });
            setLoading(false);
            return false;
        }
        if (receivedAmountValue > totalAmountValue) {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Received Amount Error", message: "Received amount cannot exceed total amount" });
            setLoading(false);
            return false;
        }
        if (receivedAmountValue > 0 && !amounts.receiving_account) {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Receiving Account Error", message: "Please select receiving account" });
            setLoading(false);
            return false;
        }

        for (let bIndex = 0; bIndex < boxes.length; bIndex++) {
            const boxItems = boxes[bIndex].items || [];
            for (let iIndex = 0; iIndex < boxItems.length; iIndex++) {
                const currentItem = boxItems[iIndex];
                const itemRate = parseFloat(currentItem.rate);
                const itemQty = parseFloat(currentItem.quantity);

                if (uomRequired && !boxItemUomOptions.includes(currentItem.uom)) {
                    setShowDetails({ show: true, color: "error", icon: "warning", title: "Item UOM Error", message: `Please choose a valid UOM for item ${iIndex + 1} in box ${bIndex + 1}` });
                    setLoading(false);
                    return false;
                }

                if (isNaN(itemRate) || itemRate <= 0) {
                    setShowDetails({ show: true, color: "error", icon: "warning", title: "Item Rate Error", message: `Please enter valid rate for item ${iIndex + 1} in box ${bIndex + 1}` });
                    setLoading(false);
                    return false;
                }

                if (isNaN(itemQty) || itemQty <= 0) {
                    setShowDetails({ show: true, color: "error", icon: "warning", title: "Item Quantity Error", message: `Please enter valid quantity for item ${iIndex + 1} in box ${bIndex + 1}` });
                    setLoading(false);
                    return false;
                }
            }
        }

        return true;
    }

    const boxValidation = async () => {

        if (newBox.length == "0" || newBox.length == "") {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Length error", message: "Please enter length" });
            return false;
        }

        if (newBox.breadth == "0" || newBox.breadth == "") {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Breadth Error", message: "Please enter breadth" });
            return false;
        }
        if (newBox.width == "0" || newBox.width == "") {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Height Error", message: "Please enter height" });
            return false;
        }
        if (newBox.weight == "0" || newBox.weight == "") {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Weight Error", message: "Please enter weight" });
            return false;
        }

        return true;
    }

    const handleFileChange = (event) => {
        // Get the selected file from the input
        const sel_file = event.target.files[0];
        if (sel_file) {
            setLoading(true);
            const formData = new FormData();
            formData.append('file', sel_file);
            console.log('File uploaded:', sel_file);
            uploadFile(formData).then((resp) => {
                console.log("File uploaded susccessfully");
                console.log(resp.data);
                let files_al = [...file];
                setFiles([...files_al, { name: sel_file.name, file: resp.data.path }]);
                setLoading(false);
            }).catch((err) => {
                console.log(err);
                setLoading(false);
            })
        }

    };

    const removeAttachment = (rm_index) => {
        if (rm_index >= 0 && rm_index < file.length) {
            // Use splice to remove the element at the specified index
            let temp = [...file];
            temp.splice(rm_index, 1);
            setFiles([...temp]);
            console.log(`Element at index ${rm_index} deleted successfully.`);
        } else {
            console.log(`Invalid index: ${rm_index}`);
        }
    }

    const viewAttachment = (rm_index) => {
        if (rm_index >= 0 && rm_index < file.length) {
            window.open(API_ENDPOINT + file[rm_index].file, '_blank');
            console.log(`Element at index ${rm_index} deleted successfully.`);
        } else {
            console.log(`Invalid index: ${rm_index}`);
        }
    }

    useEffect(() => {
        console.log("Location Parameters:", location.state);
        // Edit an existing shipment ({id}) or prefill a new one from a copy ({duplicateFrom}).
        const isEdit = !!(location.state && ("id" in location.state));
        const sourceId = isEdit ? location.state.id : (location.state && location.state.duplicateFrom);
        if (sourceId) {
            setLoading(true);
            getPackages(`_id=${sourceId}`).then((resp) => {
                console.log("Response for editing the package", resp.data);
                if (resp.data.length > 0) {
                    let details = resp.data[0];
                    if (!isEdit) setDuplicateOf({ code: details.code, awb: details.tracking_number_internal });
                    if (isEdit && details.vendor_awb) {
                        setVendorInfo({
                            vendor: details.vendor_key || "",
                            vendorAwb: details.vendor_awb,
                            awb: details.tracking_number || details.vendor_forwarding_no || "",
                            perBox: Array.isArray(details.vendor_forwarding_nos) ? details.vendor_forwarding_nos.filter(Boolean) : [],
                            status: details.vendor_booking_status,
                            hold: details.vendor_hold_remark || "",
                        });
                    }
                    setBookingDetails({
                        reference_no: details.reference_no || "",
                        shipment_content: details.shipment_content || "",
                        export_reason: details.export_reason || DEFAULT_EXPORT_REASON,
                        invoice_no: isEdit ? (details.invoice_no || "") : "",
                        invoice_date: isEdit && details.invoice_date ? moment(details.invoice_date).format("YYYY-MM-DD") : todayInput(),
                    });
                    setUomRequired(details.uom_required !== false);
                    setSender({
                        id: details.from._id,
                        name: details.from.name.toUpperCase(),
                        email: details.from.email.toUpperCase(),
                        mobile: details.from.phone,
                        phone: details.from.telephone,
                        address: details.from.address.toUpperCase(),
                        title: details.from.title ? details.from.title : "",
                        address2: details.from.address2.toUpperCase() ? details.from.address2.toUpperCase() : "",
                        address3: details.from.address3 ? details.from.address3.toUpperCase() : "",
                        city: details.from.city ? details.from.city.toUpperCase() : "",
                        pincode: details.from.pincode ? details.from.pincode.toUpperCase() : "",
                        state: details.from.state ? details.from.state.toUpperCase() : "",
                        lastname: details.from.last_name ? details.from.last_name.toUpperCase() : "",
                        company_name: details.from.company_name ? details.from.company_name.toUpperCase() : "",
                        iec: details.from.iec ? details.from.iec : "",
                        document: getSenderDocumentType(details.from),
                        document_id: getSenderDocumentNumber(details.from),
                        country: details.from.country ? { "_id": details.from.country } : null
                    });
                    setReceiver({
                        id: details.to._id,
                        name: details.to.name.toUpperCase(),
                        email: details.to.email.toUpperCase(),
                        mobile: details.to.phone,
                        phone: details.to.telephone,
                        address: details.to.address.toUpperCase(),
                        title: details.to.title ? details.to.title : "",
                        address2: details.to.address2 ? details.to.address2.toUpperCase() : "",
                        address3: details.to.address3 ? details.to.address3.toUpperCase() : "",
                        city: details.to.city ? details.to.city.toUpperCase() : "",
                        pincode: details.to.pincode ? details.to.pincode.toUpperCase() : "",
                        state: details.to.state ? details.to.state.toUpperCase() : "",
                        lastname: details.to.last_name ? details.to.last_name.toUpperCase() : "",
                        company_name: details.to.company_name ? details.to.company_name.toUpperCase() : "",
                        document: details.to.document_type || "",
                        document_id: details.to.document_type ? (details.to.aadhar || "") : "",
                        country: details.to.country ? { "_id": details.to.country } : null
                    });
                    setCarrier(details.carrier);
                    selectBranch(details.branch);
                    setPickupType(details.pickup_type);
                    const totalAmount = details.total_amount ? details.total_amount.toString() : "0";
                    // A duplicate is a new shipment — nothing has been received for it yet.
                    const receivedAmount = isEdit && details.received_amount ? details.received_amount.toString() : "0";
                    setAmounts({
                        courier_amount: details.courier_amount.toString(),
                        other_amount: details.other_amount.toString(),
                        total_amount: totalAmount,
                        received_amount: receivedAmount,
                        remaining_amount: (parseFloat(totalAmount) - parseFloat(receivedAmount)).toFixed(2).toString(),
                        receiving_account: getRefId(details.receiving_account),
                        mode: getRefId(details.payment_mode),
                        // 0 = Paid, 1 = Pending. A duplicate has received nothing yet.
                        status: isEdit ? details.payment_status : 1
                    });
                    setParcelWorkers({
                        pickup_person: getRefId(details.pickup_person),
                        assigned_person: getRefId(details.assigned_person)
                    });
                    setPackageType(details.package_type);
                    setServiceDetails({
                        weight: details.actual_weight ? details.actual_weight : "",
                        notes: details.notes || "",
                        charge_weight: details.total_weight,
                        volumetric_weight: details.volumetric_weight ? details.volumetric_weight : "",
                        shipment_value: details.shipment_value ? details.shipment_value.toString() : "",
                        vendor_chargeable_weight: details.vendor_chargeable_weight ? details.vendor_chargeable_weight.toString() : "",
                        capex_chargeable_weight: details.capex_chargeable_weight ? details.capex_chargeable_weight.toString() : "",
                    });
                    // Attachments (KYC, invoices) belong to the original shipment.
                    setFiles(isEdit && details.attachments ? details.attachments : []);
                    let box_qry = ``;
                    for (let bx of details.boxes) {
                        box_qry += `${(box_qry.length > 0) ? `&` : ``}`;
                        box_qry += `id_in=${bx}`;
                    }
                    console.log("Box query", box_qry);
                    if (box_qry !== ``) {
                        getBoxes(box_qry).then(async (resp1) => {
                            console.log(resp1.data);
                            let box_holder = []
                            for (let bxs of resp1.data) {
                                box_holder.push({
                                    ...(isEdit ? { _id: bxs._id } : {}),
                                    length: bxs.length.toString(),
                                    breadth: bxs.breadth.toString(),
                                    width: bxs.height.toString(),
                                    weight: bxs.weight.toString(),
                                    contains_medicine: !!bxs.contains_medicine,
                                    items: (bxs.items || []).map((it) => ({ ...it }))
                                });
                            }
                            setBoxes(box_holder);
                            setLoading(false);
                        }).catch((err) => {
                            console.log(err);
                            setLoading(false);
                        })
                    }
                    else {
                        setLoading(false);
                    }
                }
            }).catch((err) => {
                console.log("Error fetching the package details", err);
                setLoading(false);
            });
        }
    }, []);

    useEffect(() => {
        getCountries().then((resp) => {
            console.log(resp.data);
            setCountries(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }, [setCountries]);

    /**
     * Service details are DERIVED from the boxes: shipment value from line-item
     * rates, actual/volumetric from the box totals, and the vendor/Capex
     * chargeable weights from the per-box rounding rules (see ./weights.js).
     * With no boxes the fields stay manually editable (legacy shipments).
     */
    useEffect(() => {
        const value = shipmentValue(boxes);
        setCalculatedValue(value);
        if (boxes.length === 0) return;
        const w = shipmentWeights(boxes);
        setServiceDetails((prev) => ({
            ...prev,
            shipment_value: value.toFixed(2),
            weight: w.actual.toString(),
            volumetric_weight: w.volumetric.toString(),
            charge_weight: w.charged.toString(),
            vendor_chargeable_weight: w.vendorChargeable.toString(),
            capex_chargeable_weight: w.capexChargeable.toString(),
        }));
    }, [boxes]);

    useEffect(() => {
        getContacts().then((resp) => {
            console.log(resp.data);
            setContacts(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }, [setContacts]);

    useEffect(() => {
        getPackageType().then((resp) => {
            console.log(resp.data);
            setPackageTypes(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }, [setPackageTypes]);

    useEffect(() => {
        getCarriers().then((resp) => {
            console.log(resp.data);
            setCarriers(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }, [setCarriers]);

    useEffect(() => {
        getBranches().then((resp) => {
            console.log(resp.data);
            setBranches(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }, [setBranches]);

    useEffect(() => {
        getPaymentModes().then((resp) => {
            const modes = resp.data || [];
            setPaymentModes(modes);
            if (modes.length > 0) {
                setAmounts((prev) => {
                    const currentModeId = getRefId(prev.mode);
                    const modeExists = modes.some((m) => m._id === currentModeId);
                    if (!currentModeId || !modeExists) {
                        return { ...prev, mode: modes[0]._id };
                    }
                    return currentModeId === prev.mode ? prev : { ...prev, mode: currentModeId };
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    }, [setPaymentModes]);

    useEffect(() => {
        getReceivingAccounts().then((resp) => {
            const accounts = resp.data || [];
            setReceivingAccounts(accounts);
            if (accounts.length > 0) {
                setAmounts((prev) => {
                    const currentReceivingAccountId = getRefId(prev.receiving_account);
                    const accountExists = accounts.some((ac) => ac._id === currentReceivingAccountId);
                    if (!currentReceivingAccountId || !accountExists) {
                        return { ...prev, receiving_account: accounts[0]._id };
                    }
                    return currentReceivingAccountId === prev.receiving_account ? prev : { ...prev, receiving_account: currentReceivingAccountId };
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    }, [setReceivingAccounts]);

    useEffect(() => {
        getEmployees().then((resp) => {
            setEmployees(resp.data || []);
        }).catch((err) => {
            console.log(err);
        });
    }, [setEmployees]);

    const setSenderDetails = (details) => {
        console.log(details);
        setSender({
            id: details._id,
            name: details.name,
            email: details.email,
            mobile: details.phone,
            address: details.address,
            title: details.title ? details.title : "",
            address2: details.address2 ? details.address2 : "",
            address3: details.address3 ? details.address3 : "",
            city: details.city ? details.city : "",
            pincode: details.pincode ? details.pincode : "",
            state: details.state ? details.state : "",
            lastname: details.last_name ? details.last_name : "",
            company_name: details.company_name ? details.company_name : "",
            iec: details.iec ? details.iec : "",
            document: getSenderDocumentType(details),
            document_id: getSenderDocumentNumber(details),
            country: details.country ? details.country : null
        });
        setContactsPopup({ open: false, details: null });
    }

    const setReceiverDetails = (details) => {
        setReceiver({
            id: details._id,
            name: details.name,
            email: details.email,
            mobile: details.phone,
            address: details.address,
            title: details.title ? details.title : "",
            address2: details.address2 ? details.address2 : "",
            address3: details.address3 ? details.address3 : "",
            city: details.city ? details.city : "",
            pincode: details.pincode ? details.pincode : "",
            state: details.state ? details.state : "",
            lastname: details.last_name ? details.last_name : "",
            company_name: details.company_name ? details.company_name : "",
            document: details.document_type || "",
            document_id: details.document_type ? (details.aadhar || "") : "",
            country: details.country ? details.country : null
        });
        setReceiversPopup({ open: false, details: null });
    }

    const [errorBranch, setErrorBranch] = useState(false);


    const saveDetails = async () => {
        setLoading(true);
        // Run once: validation can ask the user to confirm (ZIP check).
        if (await validation()) {
            console.log("validated");
            updateSaveParcel();
        }
    }

    const boxCheck = async () => {
        console.log(await boxValidation());
        if (await boxValidation()) {
            let temp = { ...newBox };
            console.log("Adding New Box");
            if ((parseInt(newBox.length) > 0) && (parseInt(newBox.breadth) > 0) && (parseInt(newBox.width) > 0) && (parseInt(newBox.weight) > 0)) {
                setBoxes((prev) => [...prev, { ...temp }]);
                setNewBox({ length: "0", breadth: "0", width: "0", weight: "0", items: [], contains_medicine: false });
            }
            console.log("box added");

        }
    }



    const updateSaveParcel = async () => {
        let temp = {
            sender: {
                _id: (senderDetails.id === "") ? null : senderDetails.id,
                name: senderDetails.name.toUpperCase(),
                address: senderDetails.address.toUpperCase(),
                address2: senderDetails.address2.toUpperCase(),
                address3: senderDetails.address3.toUpperCase(),
                phone: senderDetails.mobile,
                telephone: senderDetails.phone,
                iec: senderDetails.iec,
                pincode: senderDetails.pincode.toUpperCase(),
                state: senderDetails.state.toUpperCase(),
                email: senderDetails.email.toUpperCase(),
                aadhar: senderDetails.document_id,
                document_type: senderDetails.document,
                last_name: senderDetails.lastname.toUpperCase(),
                company_name: (senderDetails.company_name || "").trim().toUpperCase(),
                title: senderDetails.title,
                city: senderDetails.city.toUpperCase(),
                country: senderDetails.country._id
            },
            receiver: {
                _id: (receiverDetails.id === "") ? null : receiverDetails.id,
                name: receiverDetails.name.toUpperCase(),
                address: receiverDetails.address.toUpperCase(),
                address2: receiverDetails.address2.toUpperCase(),
                address3: receiverDetails.address3.toUpperCase(),
                phone: receiverDetails.mobile,
                telephone: receiverDetails.phone,
                iec: receiverDetails.iec,
                pincode: receiverDetails.pincode.toUpperCase(),
                state: receiverDetails.state.toUpperCase(),
                email: receiverDetails.email.toUpperCase(),
                city: receiverDetails.city.toUpperCase(),
                aadhar: receiverDetails.document ? receiverDetails.document_id : "",
                document_type: receiverDetails.document || "",
                last_name: receiverDetails.lastname.toUpperCase(),
                company_name: (receiverDetails.company_name || "").trim().toUpperCase(),
                country: receiverDetails.country._id
            }
        };
        if ((location.state) && ("id" in location.state)) {
            temp['id'] = location.state.id;
            temp['_id'] = location.state.id;
        }
        temp['pickup_type'] = pickupType;
        temp['branch'] = selectedbranch._id;
        temp['carrier'] = carrier._id;
        temp['status'] = 0;
        temp['package_type'] = packageType._id;
        temp['is_corporate'] = false;
        temp['total_weight'] = parseFloat(serviceDetails.charge_weight);
        temp['volumetric_weight'] = parseFloat(serviceDetails.volumetric_weight);
        temp['actual_weight'] = parseFloat(serviceDetails.weight);
        temp['notes'] = serviceDetails.notes.toUpperCase();
        temp['reason'] = "";
        temp['payment_mode'] = amounts.mode;
        temp['receiving_account'] = amounts.receiving_account;
        temp['pickup_person'] = parcelWorkers.pickup_person || null;
        temp['assigned_person'] = parcelWorkers.assigned_person || null;
        temp['received_amount'] = parseFloat(amounts.received_amount || "0");
        temp['total_amount'] = parseFloat(amounts.total_amount);
        temp['courier_amount'] = parseFloat(amounts.courier_amount);
        temp['other_amount'] = parseFloat(amounts.other_amount);
        temp['payment_status'] = amounts.status;
        temp['boxes'] = [];
        temp['shipment_value'] = parseFloat(serviceDetails.shipment_value);
        temp['vendor_chargeable_weight'] = parseFloat(serviceDetails.vendor_chargeable_weight) || 0;
        temp['capex_chargeable_weight'] = parseFloat(serviceDetails.capex_chargeable_weight) || 0;
        temp['uom_required'] = uomRequired;
        temp['reference_no'] = bookingDetails.reference_no.trim();
        temp['shipment_content'] = bookingDetails.shipment_content.trim();
        temp['export_reason'] = bookingDetails.export_reason.trim();
        temp['invoice_date'] = bookingDetails.invoice_date || todayInput();
        temp['attachments'] = [...file]

        boxes.forEach((box, index) => {
            const normalizedItems = (box.items || []).map((item) => ({
                ...item,
                name: String(item.name || "").trim(),
                quantity: parseFloat(item.quantity),
                rate: parseFloat(item.rate),
                // With UOM switched off, keep a valid unit if the item had one, else blank.
                uom: boxItemUomOptions.includes(item.uom) ? item.uom : "",
                manufacturer: item.manufacturer ? item.manufacturer : ""
            }));
            temp['boxes'].push({
                ...(box._id ? { _id: box._id } : {}),
                number: (index + 1).toString(),
                length: parseFloat(box.length),
                breadth: parseFloat(box.breadth),
                height: parseFloat(box.width),
                weight: parseFloat(box.weight),
                contains_medicine: !!box.contains_medicine,
                items: normalizedItems
            })
        });
        setLoading(true);
        showLoader();
        createUpdatePackage(temp).then((resp) => {

            console.log(resp.data);

            if ((location.state) && ("id" in location.state)) {
                setShowDetails({ show: true, color: "success", icon: "success", title: "Package Edited", message: "Edited Successfully" });
            }
            else {
                setShowDetails({ show: true, color: "success", icon: "success", title: "Package Added", message: "Added Successfully" });
            }

            setLoading(false);
            setTimeout(
                function () {
                    hideLoader();
                    navigate('/packages');
                }, 2000);

        }).catch((err) => {
            hideLoader();
            console.log(err);
            setLoading(false);
        })
        console.log(temp);
    }

    /*
     * Box updates use the FUNCTIONAL form of setBoxes. Handlers live inside
     * child rows and can outlive a render; with `[...boxes]` they would write
     * back whatever list existed when they were created — which is how editing
     * box 1 used to make box 2 disappear.
     */
    const deleteBox = (index) => {
        setBoxes((prev) => prev.filter((_, i) => i !== index));
    }

    const updateBox = (index, patch) => {
        setBoxes((prev) => prev.map((b, i) => (i === index ? { ...b, ...patch } : b)));
    }

    const duplicateBox = (index) => {
        setBoxes((prev) => {
            const src = prev[index];
            if (!src) return prev;
            // A copy is a new box: drop the DB id, deep-copy the items.
            const { _id, ...rest } = src;
            const copy = { ...rest, items: (src.items || []).map((it) => ({ ...it })) };
            return [...prev.slice(0, index + 1), copy, ...prev.slice(index + 1)];
        });
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            {contacts.open && <ContactsTable isopen={contacts.open} selectSender={setSenderDetails} apply={(detail) => { setContactsPopup({ open: false, details: null }) }} details={contacts.details} handleclose={() => { setContactsPopup({ open: false, details: null }) }} />}
            {receiver.open && <ContactsTable isopen={receiver.open} selectSender={setReceiverDetails} apply={(detail) => { setReceiversPopup({ open: false, details: null }) }} details={receiver.details} handleclose={() => { setReceiversPopup({ open: false, details: null }) }} />}

            <MDBox pt={6} pb={3}>
                {vendorInfo && (
                    <MDBox mb={4} px={2} py={1.5} sx={vendorInfo.status === 3
                        ? { background: "#fff5f5", border: "1px solid #e53935", borderRadius: 2 }
                        : { background: "#e8f5e9", border: "1px solid #43a047", borderRadius: 2 }}>
                        <MDTypography variant="button" fontWeight="bold" sx={{ color: vendorInfo.status === 3 ? "#c62828" : "#2e7d32" }}>
                            {vendorInfo.status === 3 ? "Vendor booking VOIDED" : `Booked with ${vendorInfo.vendor ? vendorInfo.vendor.charAt(0).toUpperCase() + vendorInfo.vendor.slice(1) : "vendor"}`}
                            {" — "}Vendor AWB: {vendorInfo.vendorAwb}
                            {vendorInfo.status !== 3 && vendorInfo.awb ? <> · AWB: {vendorInfo.awb}</> : null}
                        </MDTypography>
                        {vendorInfo.status !== 3 && vendorInfo.perBox.length > 1 ? (
                            <MDTypography variant="caption" display="block" color="text">
                                AWB per box: {vendorInfo.perBox.map((n, i) => `Box ${i + 1}: ${n}`).join("  ·  ")}
                            </MDTypography>
                        ) : null}
                        {vendorInfo.status !== 3 && vendorInfo.hold ? (
                            <MDTypography variant="caption" display="block" fontWeight="bold" sx={{ color: "#e65100" }}>
                                ⚠ On hold at the vendor: {vendorInfo.hold}
                            </MDTypography>
                        ) : null}
                        <MDTypography variant="caption" display="block" color="text">
                            {vendorInfo.status === 3
                                ? "This waybill was cancelled. Use Book with vendor on the shipments list to book again."
                                : "Changes saved here don't update the vendor booking — if the address, boxes or items change, void it and book again."}
                        </MDTypography>
                    </MDBox>
                )}

                {duplicateOf && (
                    <MDBox mb={4} px={2} py={1.5} sx={{ background: "#e8f1fd", border: "1px solid #1A73E8", borderRadius: 2 }}>
                        <MDTypography variant="button" fontWeight="bold" color="info">
                            Duplicating shipment {duplicateOf.awb || duplicateOf.code}
                        </MDTypography>
                        <MDTypography variant="caption" display="block" color="text">
                            Sender, receiver, boxes and items are copied. Attachments and received amount are not. Review and click Create — nothing is saved until then.
                        </MDTypography>
                    </MDBox>
                )}

                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <div style={{ display: 'flex', flexWrap: "wrap", justifyContent: 'space-around', marginBottom: 30 }}>
                            <Card style={{ flex: "1", padding: 10, display: 'inline', minWidth: '500px', margin: 10 }}>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={1}
                                    px={1}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                >
                                    <MDTypography variant="h6" color="white">
                                        Sender Details
                                    </MDTypography>
                                </MDBox>
                                <MDBox pt={0}>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                    >
                                        {/* <MDInput label="Origin" style={{ flex: "3", margin: 10 }} /> */}
                                        <MDBox
                                            display="flex"
                                            flexDirection="column"
                                            alignItems="center"
                                            justifyContent="space-around">
                                            <Autocomplete

                                                disableClearable
                                                style={{ flex: "3", margin: 10 }}
                                                label={"Branch"}
                                                options={branches}
                                                getOptionLabel={(option) => option.name || ''}
                                                getOptionKey={(option) => option._id}
                                                isOptionEqualToValue={(option, value) => option._id === value._id}
                                                renderInput={(params) => <MDInput {...params} label={"Branch"} />}
                                                onChange={(event, newValue) => {
                                                    selectBranch(newValue);
                                                    console.log(newValue + "vasanthy");
                                                }}
                                                // onInputChange={handleOnChangenew}
                                                value={selectedbranch}
                                            // freeSolo
                                            />


                                        </MDBox>


                                        <MDInput label="Code" style={{ flex: "2", margin: 10 }} disabled />
                                        <Box
                                            flex="1"
                                            display={"flex"}
                                            height={"100%"}
                                        >
                                            <FormControl sx={{ flex: "1", width: "100%" }}>
                                                <InputLabel id="demo-simple-select-label">Type</InputLabel>
                                                <Select
                                                    // defaultValue=""
                                                    // IconComponent={() => { return (<ArrowDropDown />) }}
                                                    style={{ height: "1.4375em", padding: 20, marginRight: 10 }}
                                                    onChange={(event) => {
                                                        console.log(event.target.value);
                                                        setPickupType(event.target.value);
                                                    }}
                                                    displayEmpty
                                                    label={"Type"}
                                                    value={pickupType}
                                                    inputProps={{ 'aria-label': 'Without label' }}
                                                >
                                                    <MenuItem value={0}>Pickup</MenuItem>
                                                    <MenuItem value={1}>Walk-in</MenuItem>
                                                    <MenuItem value={2}>Corporate</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                    >
                                        {/* Optional: sent to vendors as "Company Name"; the person below goes as "Contact Name". */}
                                        <MDInput label="Company Name (optional)"
                                            style={{ flex: 7, width: "100%", margin: 10 }}
                                            inputProps={{ maxLength: 40 }}
                                            helperText="Goes to Worldfirst as Company Name — the name below as Contact Name"
                                            value={senderDetails.company_name || ""}
                                            onChange={(event) => {
                                                setSender({ ...senderDetails, company_name: event.target.value, id: null });
                                            }}
                                        />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                    >
                                        <MDInput label="First Name"
                                            style={{ flex: 7, width: "100%", margin: 10 }}

                                            value={senderDetails.name}
                                            onChange={(event) => {
                                                setSender({ ...senderDetails, name: event.target.value, id: null });
                                            }}
                                        />
                                        <MDButton label="Name" style={{ flex: 1, width: "100%", margin: 10 }} iconOnly
                                            onClick={() => {
                                                console.log("Finding the details");
                                                setContactsPopup({ open: true, details: contactList });
                                            }}><Icon>search</Icon></MDButton>
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"

                                    >
                                        <MDInput label="Last Name" style={{ flex: 4, width: "100%", margin: 10 }}
                                            value={senderDetails.lastname}
                                            onChange={(event) => {
                                                setSender({ ...senderDetails, lastname: event.target.value, id: null });
                                            }} />
                                        <Box
                                            flex="1"
                                            display={"flex"}
                                            height={"100%"}
                                        >
                                            <FormControl sx={{ flex: "1", width: "100%" }}>
                                                <InputLabel id="demo-simple-select-label">Title</InputLabel>
                                                <Select

                                                    // IconComponent={() => { return (<ArrowDropDown />) }}
                                                    style={{ height: "1.4375em", padding: 20, marginRight: 10 }}
                                                    onChange={(event) => {
                                                        console.log(event.target.value);
                                                        setSender({ ...senderDetails, title: event.target.value });
                                                    }}
                                                    displayEmpty
                                                    value={senderDetails.title}
                                                    label={"Title"}
                                                    inputProps={{ 'aria-label': 'Without label' }}
                                                >
                                                    <MenuItem value={"S/O"}>S/O</MenuItem>
                                                    <MenuItem value={"D/O"}>D/O</MenuItem>
                                                    <MenuItem value={"W/O"}>W/O</MenuItem>
                                                    <MenuItem value={"C/O"}>C/O</MenuItem>
                                                    <MenuItem value={"NAN"}>NaN</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                    >
                                        <MDInput label="Address 1" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={senderDetails.address}
                                            onChange={(event) => {
                                                setSender({ ...senderDetails, address: event.target.value, id: null });
                                            }} />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"

                                    >
                                        {/* Live preview of the two vendor address lines (red if it won't fit). */}
                                        <MDInput label="Address 2" style={{ flex: 1, width: "100%", margin: 10 }}
                                            error={wrapAddress([senderDetails.address, senderDetails.address2, senderDetails.address3]).overflow}
                                            helperText={vendorAddressHint(wrapAddress([senderDetails.address, senderDetails.address2, senderDetails.address3]))}
                                            FormHelperTextProps={{ sx: { color: wrapAddress([senderDetails.address, senderDetails.address2, senderDetails.address3]).overflow ? "error.main" : "text.secondary" } }}
                                            value={senderDetails.address2}
                                            onChange={(event) => {
                                                setSender({ ...senderDetails, address2: event.target.value, id: null });
                                            }} />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"

                                    >
                                        {/* Worldfirst/ICL/Atlantic (Xpresion) take only two address lines. */}
                                        <MDInput label="Address 3" style={{ flex: 1, width: "100%", margin: 10 }}
                                            error
                                            helperText="Don't use for Worldfirst, ICL or Atlantic shipments — the vendor address has only 2 lines"
                                            FormHelperTextProps={{ sx: { color: "error.main", fontWeight: 500 } }}
                                            value={senderDetails.address3}
                                            onChange={(event) => {
                                                setSender({ ...senderDetails, address3: event.target.value, id: null });
                                            }} />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"

                                    >
                                        <MDInput label="Pincode" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={senderDetails.pincode}
                                            onChange={(event) => {
                                                setSender({ ...senderDetails, pincode: event.target.value, id: null });
                                            }} />
                                        <MDInput label="City" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={senderDetails.city}
                                            onChange={(event) => {
                                                setSender({ ...senderDetails, city: event.target.value, id: null });
                                            }} />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"

                                    >
                                        <MDInput label="State" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={senderDetails.state}
                                            onChange={(event) => {
                                                setSender({ ...senderDetails, state: event.target.value, id: null });
                                            }} />
                                        <MDInput label="Mobile" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={senderDetails.mobile}
                                            onChange={(event) => {
                                                setSender({ ...senderDetails, mobile: event.target.value, id: null });
                                            }} />

                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"

                                    >
                                        <MDInput label="Additional Number" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={senderDetails.phone}
                                            onChange={(event) => {
                                                setSender({ ...senderDetails, phone: event.target.value, id: null });
                                            }} />
                                        <MDInput label="Email" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={senderDetails.email}
                                            onChange={(event) => {
                                                setSender({ ...senderDetails, email: event.target.value, id: null });
                                            }} />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"

                                    >
                                        {/* <MDInput label="Country" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={senderDetails.country}
                                            onChange={(event) => {
                                                setSender({ ...senderDetails, country: event.target.value, id: null });
                                            }} /> */}
                                        <Autocomplete
                                            disableClearable
                                            style={{ flex: 1, margin: 10 }}
                                            label={"Country"}
                                            disabled
                                            options={countries}
                                            getOptionLabel={(option) => option.name || ''}
                                            isOptionEqualToValue={(option, value) => {
                                                let temp = (option._id === value?._id);
                                                if (temp) {
                                                    if (!value?.name) {
                                                        setSender({ ...senderDetails, country: { ...option } });
                                                    }
                                                }
                                                return temp;
                                            }}
                                            renderInput={(params) => <MDInput {...params} label={"Country"} />}
                                            onChange={(event, newValue) => {
                                                setSender({ ...senderDetails, country: newValue, id: null });
                                                console.log(newValue);
                                            }}
                                            // onInputChange={handleOnChangenew}
                                            value={senderDetails.country}
                                        // freeSolo
                                        />
                                        <MDInput label="IEC" style={{ flex: 1, width: "100%", margin: 10 }} disabled
                                            value={senderDetails.iec}
                                            onChange={(event) => {
                                                setSender({ ...senderDetails, iec: event.target.value, id: null });
                                            }} />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"

                                    >
                                        <Box
                                            flex="1"
                                            display={"flex"}
                                            height={"100%"}
                                        >
                                            <FormControl sx={{ flex: "1", width: "100%" }}>
                                                <InputLabel id="demo-simple-select-label">Document</InputLabel>
                                                <Select
                                                    // IconComponent={() => { return (<ArrowDropDown />) }}
                                                    style={{ height: "1.4375em", padding: 20, marginRight: 10 }}
                                                    onChange={(event) => {
                                                        setSender({ ...senderDetails, document: event.target.value, document_id: "", id: null });
                                                    }}
                                                    displayEmpty
                                                    label={"Document"}
                                                    inputProps={{ 'aria-label': 'Without label' }}
                                                    value={senderDetails.document}
                                                >
                                                    {senderDocumentOptions.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        {/* <MDInput label="Document" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={senderDetails.document}
                                            onChange={(event) => {
                                                setSender({ ...senderDetails, document: event.target.value, id: null });
                                            }} /> */}
                                        <MDInput label="Document No." style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={senderDetails.document_id}
                                            onChange={(event) => {
                                                setSender({ ...senderDetails, document_id: event.target.value, id: null });
                                            }} />
                                    </MDBox>
                                </MDBox>
                            </Card>
                            <Card style={{ flex: "1", padding: 10, display: 'inline', minWidth: '500px', margin: 10 }}>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={1}
                                    px={1}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                >
                                    <MDTypography variant="h6" color="white">
                                        Receiver Details
                                    </MDTypography>
                                </MDBox>
                                <MDBox pt={0}>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                    >

                                        {/* <MDInput label="Destination" style={{ flex: "3", margin: 10 }} /> */}
                                        <Autocomplete
                                            style={{ flex: 3, margin: 10 }}
                                            label={"Destination"}
                                            options={countries}
                                            getOptionLabel={(option) => option.name || ''}
                                            renderInput={(params) => <MDInput {...params} label={"Destination"} />}
                                            onChange={(event, newValue) => {
                                                setReceiver({ ...receiverDetails, country: newValue, id: null });
                                                console.log(newValue);
                                            }}
                                            // onInputChange={handleOnChangenew}
                                            value={receiverDetails.country}
                                        // freeSolo
                                        />
                                        <MDInput label="Code" style={{ flex: "2", margin: 10 }} disabled />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"

                                    >
                                        {/* <MDInput label="Name" style={{ flex: 7, width: "100%", margin: 10 }} />
                                        <MDButton label="Name" style={{ flex: 1, width: "100%", margin: 10 }} iconOnly><Icon>search</Icon></MDButton> */}
                                        {/* Optional: sent to vendors as "Company Name"; the person below goes as "Contact Name". */}
                                        <MDInput label="Company Name (optional)"
                                            style={{ flex: 7, width: "100%", margin: 10 }}
                                            inputProps={{ maxLength: 40 }}
                                            helperText="Goes to Worldfirst as Company Name — the name below as Contact Name"
                                            value={receiverDetails.company_name || ""}
                                            onChange={(event) => {
                                                setReceiver({ ...receiverDetails, company_name: event.target.value, id: null });
                                            }}
                                        />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                    >
                                        <MDInput label="Full Name"
                                            style={{ flex: 7, width: "100%", margin: 10 }}
                                            value={receiverDetails.name}
                                            onChange={(event) => {
                                                setReceiver({ ...receiverDetails, name: event.target.value, id: null });
                                            }}
                                        />
                                        <MDButton label="Name" style={{ flex: 1, width: "100%", margin: 10 }} iconOnly
                                            onClick={() => {
                                                console.log("Fincding the details");
                                                setReceiversPopup({ open: true, details: contactList });
                                            }}><Icon>search</Icon></MDButton>
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"

                                    >
                                        <MDInput label="Address 1" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={receiverDetails.address}
                                            onChange={(event) => {
                                                setReceiver({ ...receiverDetails, address: event.target.value, id: null });
                                            }} />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"

                                    >
                                        {/* Live preview of the two vendor address lines (red if it won't fit). */}
                                        <MDInput label="Address 2" style={{ flex: 1, width: "100%", margin: 10 }}
                                            error={wrapAddress([receiverDetails.address, receiverDetails.address2, receiverDetails.address3]).overflow}
                                            helperText={vendorAddressHint(wrapAddress([receiverDetails.address, receiverDetails.address2, receiverDetails.address3]))}
                                            FormHelperTextProps={{ sx: { color: wrapAddress([receiverDetails.address, receiverDetails.address2, receiverDetails.address3]).overflow ? "error.main" : "text.secondary" } }}
                                            value={receiverDetails.address2}
                                            onChange={(event) => {
                                                setReceiver({ ...receiverDetails, address2: event.target.value, id: null });
                                            }} />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"

                                    >
                                        {/* Worldfirst/ICL/Atlantic (Xpresion) take only two address lines. */}
                                        <MDInput label="Address 3" style={{ flex: 1, width: "100%", margin: 10 }}
                                            error
                                            helperText="Don't use for Worldfirst, ICL or Atlantic shipments — the vendor address has only 2 lines"
                                            FormHelperTextProps={{ sx: { color: "error.main", fontWeight: 500 } }}
                                            value={receiverDetails.address3}
                                            onChange={(event) => {
                                                setReceiver({ ...receiverDetails, address3: event.target.value, id: null });
                                            }} />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="flex-start"
                                        justifyContent="space-around">
                                        {/* US / CA / AU: the ZIP check shows the ZIP's town and state. */}
                                        <MDInput label="Pincode" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={receiverDetails.pincode}
                                            error={zipHint.error}
                                            helperText={zipHint.text}
                                            onChange={(event) => {
                                                setReceiver({ ...receiverDetails, pincode: event.target.value, id: null });
                                            }} />
                                        <MDInput label="City" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={receiverDetails.city}
                                            error={cityMismatch(zipNow, receiverDetails.city)}
                                            helperText={cityMismatch(zipNow, receiverDetails.city) ? (
                                                <span>
                                                    ZIP {receiverDetails.pincode.trim()} is {townNames(zipNow).slice(0, 3).join(" / ")}
                                                    {zipNow.places.length === 1 ? <> — {fixLink(() => setReceiver({ ...receiverDetails, city: zipNow.places[0].toUpperCase(), id: null }))}</> : null}
                                                </span>
                                            ) : ""}
                                            onChange={(event) => {
                                                setReceiver({ ...receiverDetails, city: event.target.value, id: null });
                                            }} />
                                        {/* <MDInput label="Pincode" style={{ flex: 1, width: "100%", margin: 10 }} />
                                        <MDInput label="City" style={{ flex: 1, width: "100%", margin: 10 }} /> */}
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="flex-start"
                                        justifyContent="space-around"

                                    >
                                        {receiverStateCountry ? (
                                            // USA / Canada / Australia: pick from the list (the vendor needs a real state code).
                                            <Autocomplete
                                                style={{ flex: 1, margin: 10 }}
                                                options={stateOptions(receiverStateCountry)}
                                                getOptionLabel={(option) => option.label || ""}
                                                isOptionEqualToValue={(option, value) => option.code === value.code}
                                                value={findStateOption(receiverDetails.state, receiverStateCountry)}
                                                onChange={(event, option) => {
                                                    setReceiver({ ...receiverDetails, state: option ? option.value : "", id: null });
                                                }}
                                                renderInput={(params) => {
                                                    const unknown = receiverDetails.state && !findStateOption(receiverDetails.state, receiverStateCountry);
                                                    const mismatch = !unknown && stateMismatch(zipNow, receiverDetails.state, receiverStateCountry);
                                                    let helper = "";
                                                    if (unknown) helper = `"${receiverDetails.state}" isn't a valid ${receiverStateCountry} state — pick one from the list`;
                                                    else if (mismatch) {
                                                        helper = (
                                                            <span>
                                                                ZIP {receiverDetails.pincode.trim()} is in {zipStateLabel(zipNow, receiverStateCountry)}
                                                                {zipNow.states.length === 1 ? <> — {fixLink(() => setReceiver({ ...receiverDetails, state: zipNow.states[0].name, id: null }))}</> : null}
                                                            </span>
                                                        );
                                                    }
                                                    return (
                                                        <MDInput {...params} label="State"
                                                            error={!!unknown || mismatch}
                                                            helperText={helper} />
                                                    );
                                                }}
                                            />
                                        ) : (
                                            <MDInput label="State" style={{ flex: 1, width: "100%", margin: 10 }}
                                                value={receiverDetails.state}
                                                onChange={(event) => {
                                                    setReceiver({ ...receiverDetails, state: event.target.value, id: null });
                                                }} />
                                        )}
                                        <MDInput label="Mobile" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={receiverDetails.mobile}
                                            onChange={(event) => {
                                                setReceiver({ ...receiverDetails, mobile: event.target.value, id: null });
                                            }} />

                                    </MDBox>
                                    {/* Opens the full address in Google Maps (new tab) to check the street, town, state and ZIP. */}
                                    <MDBox display="flex" justifyContent="flex-end" mx={1.25} mt={-0.5} mb={0.5}>
                                        <MDButton variant="outlined" color="info" size="small"
                                            disabled={!String(receiverDetails.address || "").trim()}
                                            onClick={() => {
                                                const country = receiverDetails.country
                                                    ? receiverDetails.country.name || (countries.find((c) => c._id === receiverDetails.country._id) || {}).name
                                                    : "";
                                                const url = mapsSearchUrl([receiverDetails.address, receiverDetails.address2, receiverDetails.address3,
                                                    receiverDetails.city, receiverDetails.state, receiverDetails.pincode, country]);
                                                if (url) window.open(url, "_blank", "noopener,noreferrer");
                                            }}>
                                            <Icon>map</Icon>&nbsp;Check address on Google Maps
                                        </MDButton>
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"

                                    >
                                        <MDInput label="Additional Number" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={receiverDetails.phone}
                                            onChange={(event) => {
                                                setReceiver({ ...receiverDetails, phone: event.target.value, id: null });
                                            }} />

                                        <MDInput label="Email" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={receiverDetails.email}
                                            onChange={(event) => {
                                                setReceiver({ ...receiverDetails, email: event.target.value, id: null });
                                            }} />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"

                                    >
                                        <Autocomplete
                                            disableClearable
                                            style={{ flex: 1, margin: 10 }}
                                            label={"Country"}
                                            options={countries}
                                            getOptionLabel={(option) => option.name || ''}
                                            isOptionEqualToValue={(option, value) => {
                                                let temp = (option._id === value?._id);
                                                if (temp) {
                                                    if (!value?.name) {
                                                        setReceiver({ ...receiverDetails, country: { ...option } });
                                                    }
                                                }
                                                return temp;
                                            }}
                                            renderInput={(params) => <MDInput {...params} label={"Country"} />}
                                            onChange={(event, newValue) => {
                                                setReceiver({ ...receiverDetails, country: newValue, id: null });
                                                console.log(newValue);
                                            }}
                                            // onInputChange={handleOnChangenew}
                                            value={receiverDetails.country}
                                        // freeSolo
                                        />
                                        <MDInput label="IEC" style={{ flex: 1, width: "100%", margin: 10 }}
                                            disabled
                                            value={receiverDetails.iec}

                                            onChange={(event) => {
                                                setReceiver({ ...receiverDetails, iec: event.target.value, id: null });
                                            }} />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                    >
                                        {/* Optional for the receiver — left unselected unless needed. */}
                                        <Box flex="1" display={"flex"} height={"100%"}>
                                            <FormControl sx={{ flex: "1", width: "100%" }}>
                                                <InputLabel id="receiver-document-label">Document</InputLabel>
                                                <Select
                                                    labelId="receiver-document-label"
                                                    style={{ height: "1.4375em", padding: 20, marginRight: 10 }}
                                                    value={receiverDetails.document || ""}
                                                    label={"Document"}
                                                    onChange={(event) => {
                                                        const v = event.target.value;
                                                        setReceiver({ ...receiverDetails, document: v, document_id: v ? receiverDetails.document_id : "", id: null });
                                                    }}
                                                >
                                                    <MenuItem value=""><em>None</em></MenuItem>
                                                    {senderDocumentOptions.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        <MDInput
                                            label="Document No." style={{ flex: 1, width: "100%", margin: 10 }}
                                            disabled={!receiverDetails.document}
                                            value={receiverDetails.document_id}
                                            onChange={(event) => {
                                                setReceiver({ ...receiverDetails, document_id: event.target.value, id: null });
                                            }} />
                                    </MDBox>
                                </MDBox>
                            </Card>
                            <Card style={{ flex: "1", padding: 10, display: 'inline', minWidth: '500px', margin: 10 }}>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={1}
                                    px={1}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                >
                                    <MDTypography variant="h6" color="white">
                                        Service Details
                                    </MDTypography>
                                </MDBox>
                                <MDBox pt={0}>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                    >
                                        {/* <MDInput label="Carrier" style={{ flex: 7, width: "100%", margin: 10 }} /> */}
                                        <Autocomplete
                                            disableClearable
                                            style={{ flex: "7", margin: 10 }}
                                            label="Carrier"
                                            options={carriers}
                                            getOptionLabel={(option) => option.name || ''}
                                            renderInput={(params) => <MDInput {...params} label="Carrier" />}
                                            onChange={(event, newValue) => {
                                                setCarrier(newValue);
                                            }}
                                            // onInputChange={handleOnChangenew}
                                            value={carrier}
                                        // freeSolo
                                        />
                                        {/* <MDButton style={{ flex: 1, width: "100%", margin: 10 }} iconOnly><Icon>search</Icon></MDButton> */}
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                    >
                                        <MDInput label="Service" style={{ flex: 7, width: "100%", margin: 10 }} disabled />
                                        <MDButton style={{ flex: 1, width: "100%", margin: 10 }} disabled iconOnly><Icon>search</Icon></MDButton>
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                    >
                                        {/* <MDInput label="Product" style={{ flex: 7, width: "100%", margin: 10 }} /> */}
                                        <Autocomplete
                                            disableClearable
                                            style={{ flex: "7", margin: 10 }}
                                            label="Package Type"
                                            options={packageTypes}
                                            getOptionLabel={(option) => option.name || ''}
                                            renderInput={(params) => <MDInput {...params} label="Package Type" />}
                                            onChange={(event, newValue) => {
                                                setPackageType(newValue);
                                            }}
                                            // onInputChange={handleOnChangenew}
                                            value={packageType}
                                        // freeSolo
                                        />
                                        {/* <MDButton style={{ flex: 1, width: "100%", margin: 10 }} iconOnly><Icon>search</Icon></MDButton> */}
                                    </MDBox>
                                    {/* ── Vendor booking details (sent to Worldfirst / ICL) ── */}
                                    <MDBox display="flex" flexDirection="row" alignItems="center" justifyContent="space-around">
                                        <MDInput label="Reference No" required style={{ flex: 1, margin: 10 }}
                                            value={bookingDetails.reference_no}
                                            placeholder="e.g. WF141 - WM"
                                            inputProps={{ maxLength: 30 }}
                                            error={refMissing && !bookingDetails.reference_no.trim()}
                                            helperText={refMissing && !bookingDetails.reference_no.trim()
                                                ? "Reference No is required"
                                                : "Branch reference shown in the vendor portal (max 30)"}
                                            onChange={(event) => setBookingDetails({ ...bookingDetails, reference_no: event.target.value })} />
                                    </MDBox>
                                    <MDBox display="flex" flexDirection="row" alignItems="center" justifyContent="space-around">
                                        <MDInput label="Content" style={{ flex: 1, margin: 10 }}
                                            value={bookingDetails.shipment_content}
                                            placeholder={(() => {
                                                const names = boxes.flatMap((b) => (b.items || []).map((it) => it.name)).filter(Boolean);
                                                return names.length ? names.join(", ") : "What's in the shipment";
                                            })()}
                                            helperText="Leave blank to use the item names"
                                            onChange={(event) => setBookingDetails({ ...bookingDetails, shipment_content: event.target.value })} />
                                    </MDBox>
                                    <MDBox display="flex" flexDirection="row" alignItems="center" justifyContent="space-around">
                                        <MDInput label="Invoice No" style={{ flex: 1, margin: 10 }}
                                            value={bookingDetails.invoice_no}
                                            placeholder="Assigned automatically"
                                            InputLabelProps={{ shrink: true }}
                                            disabled />
                                        <MDInput label="Invoice Date" type="date" style={{ flex: 1, margin: 10 }}
                                            InputLabelProps={{ shrink: true }}
                                            value={bookingDetails.invoice_date}
                                            onChange={(event) => setBookingDetails({ ...bookingDetails, invoice_date: event.target.value })} />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                    >
                                        <MDInput label={boxes.length ? "Shipment Value (from items)" : "Shipment Value"} style={{ flex: "5", margin: 10 }}
                                            disabled={boxes.length > 0}
                                            value={serviceDetails.shipment_value}
                                            onChange={(event) => {
                                                setServiceDetails({ ...serviceDetails, shipment_value: event.target.value });
                                            }} />
                                        <Box
                                            flex="1"
                                            display={"flex"}
                                            height={"100%"}
                                        >
                                            <FormControl sx={{ flex: "1", width: "100%" }}>
                                                <Select
                                                    defaultValue={0}
                                                    // IconComponent={() => { return (<ArrowDropDown />) }}
                                                    style={{ height: "1.4375em", padding: 20, marginRight: 10 }}
                                                    onChange={(event) => {
                                                        console.log(event.target.value);
                                                    }}
                                                    displayEmpty
                                                    inputProps={{ 'aria-label': 'Without label' }}
                                                >
                                                    <MenuItem value={0}>INR</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                    >
                                        <MDInput label="Pieces" style={{ flex: "5", margin: 10 }} disabled value={boxes.length.toString()} />
                                        <Box
                                            flex="1"
                                            display={"flex"}
                                            height={"100%"}
                                        >
                                            <FormControl sx={{ flex: "1", width: "100%" }}>
                                                <Select
                                                    defaultValue={0}
                                                    // IconComponent={() => { return (<ArrowDropDown />) }}
                                                    style={{ height: "1.4375em", padding: 20, marginRight: 10 }}
                                                    onChange={(event) => {
                                                        console.log(event.target.value);
                                                    }}
                                                    displayEmpty
                                                    inputProps={{ 'aria-label': 'Without label' }}
                                                >
                                                    <MenuItem value={0}>BOX</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                    >
                                        <MDInput label={boxes.length ? "Actual Weight (box total)" : "Actual Weight"} style={{ flex: "5", margin: 10 }}
                                            disabled={boxes.length > 0}
                                            value={serviceDetails.weight}
                                            onChange={(event) => {

                                                if (parseFloat(event.target.value) > parseFloat(serviceDetails.volumetric_weight)) {
                                                    setServiceDetails({ ...serviceDetails, weight: event.target.value, charge_weight: event.target.value })
                                                } else {
                                                    setServiceDetails({ ...serviceDetails, weight: event.target.value, charge_weight: serviceDetails.volumetric_weight })
                                                }
                                            }} />
                                        <Box
                                            flex="1"
                                            display={"flex"}
                                            height={"100%"}
                                        >
                                            <FormControl sx={{ flex: "1", width: "100%" }}>
                                                <Select
                                                    defaultValue={0}
                                                    // IconComponent={() => { return (<ArrowDropDown />) }}
                                                    style={{ height: "1.4375em", padding: 20, marginRight: 10 }}
                                                    onChange={(event) => {
                                                        console.log(event.target.value);
                                                    }}
                                                    displayEmpty
                                                    inputProps={{ 'aria-label': 'Without label' }}
                                                >
                                                    <MenuItem value={0}>Kgs</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"

                                    >
                                        <MDInput label={boxes.length ? "Volumetric (box total)" : "Volumetric Weight"} style={{ flex: 1, width: "100%", margin: 10 }}
                                            disabled={boxes.length > 0}
                                            value={serviceDetails.volumetric_weight}
                                            onChange={(event) => {
                                                if (parseFloat(event.target.value) > parseFloat(serviceDetails.weight)) {
                                                    setServiceDetails({ ...serviceDetails, volumetric_weight: event.target.value, charge_weight: event.target.value })
                                                } else {
                                                    setServiceDetails({ ...serviceDetails, volumetric_weight: event.target.value, charge_weight: serviceDetails.weight })
                                                }

                                            }} />
                                        <MDInput label="Charged Weight" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={serviceDetails.charge_weight}
                                            disabled
                                            onChange={(event) => { setServiceDetails({ ...serviceDetails, charge_weight: event.target.value }) }} />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                    >
                                        <MDInput label="Vendor Chargeable Weight" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={serviceDetails.vendor_chargeable_weight}
                                            disabled
                                            helperText="Each box up to next 0.5 kg, total to whole kg" />
                                        <MDInput label="Capex Chargeable Weight" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={serviceDetails.capex_chargeable_weight}
                                            disabled
                                            helperText="Each box up to next whole kg" />
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </div>
                        <Card style={{ padding: 20 }}>
                            <MDBox
                                mx={-1}
                                mt={-4}
                                py={1}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Box Details
                                </MDTypography>
                            </MDBox>
                            <div style={{ display: "flex", alignItems: "center", margin: 10 }}>
                                <div style={{ display: "flex", flexWrap: "wrap", minWidth: "500px", justifyContent: "space-around", width: "100%", alignItems: 'center' }}>
                                    <MDInput label={"Number"} disabled value={(boxes.length + 1).toString()} />
                                    <MDInput label={"Length(cm)"} value={newBox.length} onChange={(event) => { setNewBox({ ...newBox, length: event.target.value }) }} />
                                    <MDInput label={"Breadth(cm)"} value={newBox.breadth} onChange={(event) => { setNewBox({ ...newBox, breadth: event.target.value }) }} />
                                    <MDInput label={"Height(cm)"} value={newBox.width} onChange={(event) => { setNewBox({ ...newBox, width: event.target.value }) }} />
                                    <MDInput label={"Weight(KG)"} value={newBox.weight} onChange={(event) => { setNewBox({ ...newBox, weight: event.target.value }) }} />
                                    <MDButton variant="gradient" color="light" style={{ margin: 10 }}
                                        onClick={() => {
                                            boxCheck();
                                        }}>
                                        Add box<Icon>add</Icon>
                                    </MDButton>
                                </div>
                            </div>
                            <MDBox style={{ paddingTop: 20 }}>
                                <MDBox display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1} px={1}>
                                    <MDBox>
                                        <MDTypography variant="h6">Boxes ({boxes.length})</MDTypography>
                                        <MDTypography variant="button" color="text">Shipment Value : {calculatedValue.toFixed(2)}</MDTypography>
                                    </MDBox>
                                    <FormControl sx={{ minWidth: 300 }}>
                                        <InputLabel id="export-reason-label">Export Reason</InputLabel>
                                        <Select
                                            labelId="export-reason-label"
                                            label="Export Reason"
                                            value={bookingDetails.export_reason || ""}
                                            style={{ height: "1.4375em", padding: 20 }}
                                            onChange={(event) => setBookingDetails({ ...bookingDetails, export_reason: event.target.value })}
                                        >
                                            <MenuItem value=""><em>Select</em></MenuItem>
                                            {EXPORT_REASONS.map((r) => <MenuItem key={r} value={r}>{r}</MenuItem>)}
                                            {/* keep an older free-text value visible instead of silently dropping it */}
                                            {bookingDetails.export_reason && !EXPORT_REASONS.includes(bookingDetails.export_reason) && (
                                                <MenuItem value={bookingDetails.export_reason}>{bookingDetails.export_reason} (not in Worldfirst list)</MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                    <FormControlLabel
                                        control={<Switch checked={uomRequired} onChange={(event) => setUomRequired(event.target.checked)} />}
                                        label={
                                            <MDTypography variant="button" fontWeight="regular">
                                                Include UOM for items {uomRequired ? "" : "(off — UOM not required for this shipment)"}
                                            </MDTypography>
                                        }
                                    />
                                </MDBox>
                                {boxes.map((row, index) => (
                                    <BoxRow
                                        key={index}
                                        rowData={{ ...row, number: index + 1 }}
                                        updateBox={updateBox}
                                        deleteBox={deleteBox}
                                        duplicateBox={duplicateBox}
                                        uomRequired={uomRequired}
                                    />
                                ))}
                                {/* <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Number</TableCell>
                                                <TableCell>Length</TableCell>
                                                <TableCell>Breadth</TableCell>
                                                <TableCell>Height</TableCell>
                                                <TableCell>Weight</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data.map((row, index) => (
                                                <BoxRow key={index} rowData={row} />
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer> */}
                            </MDBox>
                        </Card>
                        <div style={{ display: 'flex', flexWrap: "wrap", justifyContent: 'space-around', marginBottom: 30, marginTop: 50 }}>
                            <Card style={{ flex: "1", padding: 10, display: 'inline', minWidth: '500px', margin: 10 }}>
                                <MDBox
                                    mx={-1}
                                    mt={-4}
                                    py={1}
                                    px={2}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                >
                                    <MDTypography variant="h6" color="white">
                                        Service Details
                                    </MDTypography>
                                </MDBox>
                                <MDBox pt={0}>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                        style={{ marginTop: 10 }}
                                    >
                                        <Box flex="1" display={"flex"} height={"100%"}>
                                            <FormControl sx={{ flex: "1", width: "100%" }}>
                                                <InputLabel id="pickup-person-select-label" style={{ marginLeft: 10, marginRight: 10 }}>Pickup Person</InputLabel>
                                                <Select
                                                    value={parcelWorkers.pickup_person}
                                                    style={{ height: "1.4375em", padding: 20, marginLeft: 10, marginRight: 10 }}
                                                    onChange={(event) => {
                                                        setParcelWorkers({ ...parcelWorkers, pickup_person: event.target.value });
                                                    }}
                                                    displayEmpty
                                                    label={"Pickup Person"}
                                                    inputProps={{ 'aria-label': 'Without label' }}
                                                >
                                                    <MenuItem value=""></MenuItem>
                                                    {getSelectableEmployees(employees, parcelWorkers.pickup_person).map((employee) => (
                                                        <MenuItem key={employee._id} value={employee._id}>
                                                            {employee.name} ({employee.code}){employee.is_active ? "" : " - Inactive"}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        <Box flex="1" display={"flex"} height={"100%"}>
                                            <FormControl sx={{ flex: "1", width: "100%" }}>
                                                <InputLabel id="assigned-person-select-label" style={{ marginLeft: 10, marginRight: 10 }}>Assigned Person</InputLabel>
                                                <Select
                                                    value={parcelWorkers.assigned_person}
                                                    style={{ height: "1.4375em", padding: 20, marginLeft: 10, marginRight: 10 }}
                                                    onChange={(event) => {
                                                        setParcelWorkers({ ...parcelWorkers, assigned_person: event.target.value });
                                                    }}
                                                    displayEmpty
                                                    label={"Assigned Person"}
                                                    inputProps={{ 'aria-label': 'Without label' }}
                                                >
                                                    <MenuItem value=""></MenuItem>
                                                    {getSelectableEmployees(employees, parcelWorkers.assigned_person).map((employee) => (
                                                        <MenuItem key={employee._id} value={employee._id}>
                                                            {employee.name} ({employee.code}){employee.is_active ? "" : " - Inactive"}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                    >
                                        {/* <MDInput label="Origin" style={{ flex: "3", margin: 10 }} /> */}
                                        <MDInput label={"Notes"} multiline rows={5} style={{ margin: 10, flex: 1 }}
                                            value={serviceDetails.notes}
                                            onChange={(event) => {
                                                setServiceDetails({ ...serviceDetails, notes: event.target.value });
                                            }}></MDInput>
                                    </MDBox>
                                    <Attachments files={file} removeAttachment={removeAttachment} viewAttachment={viewAttachment} />
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                    >
                                        {/* <MDInput label="Origin" style={{ flex: "3", margin: 10 }} /> */}

                                        <MDInput type="file" style={{ margin: 10, flex: 1 }} disabled={load} onChange={handleFileChange}></MDInput>
                                    </MDBox>
                                </MDBox>
                            </Card>
                            <Card style={{ flex: "1", padding: 10, display: 'inline', minWidth: '500px', margin: 10 }}>
                                <MDBox
                                    mx={-1}
                                    mt={-4}
                                    py={1}
                                    px={2}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                >
                                    <MDTypography variant="h6" color="white">
                                        Payment Details
                                    </MDTypography>
                                </MDBox>
                                <MDBox pt={0}>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"

                                    >
                                        <MDInput label="Courier Amount" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={amounts.courier_amount}
                                            onChange={(event) => {
                                                const totalAmount = (parseFloat(amounts.other_amount) + parseFloat(event.target.value)).toFixed(2).toString();
                                                const remainingAmount = (parseFloat(totalAmount) - parseFloat(amounts.received_amount || "0")).toFixed(2).toString();
                                                setAmounts({ ...amounts, courier_amount: event.target.value, total_amount: totalAmount, remaining_amount: remainingAmount })
                                            }} />
                                        <MDInput label="Other Amount" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={amounts.other_amount}
                                            onChange={(event) => {
                                                const totalAmount = (parseFloat(amounts.courier_amount) + parseFloat(event.target.value)).toFixed(2).toString();
                                                const remainingAmount = (parseFloat(totalAmount) - parseFloat(amounts.received_amount || "0")).toFixed(2).toString();
                                                setAmounts({ ...amounts, other_amount: event.target.value, total_amount: totalAmount, remaining_amount: remainingAmount })
                                            }} />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"

                                    >
                                        <MDInput label="Total Amount" style={{ flex: 1, width: "100%", margin: 10 }} disabled
                                            value={amounts.total_amount}
                                            onChange={(event) => {
                                                setAmounts({ ...amounts, courier_amount: event.target.value })
                                            }} />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                    >
                                        <MDInput label="Received Amount" style={{ flex: 1, width: "100%", margin: 10 }}
                                            value={amounts.received_amount}
                                            onChange={(event) => {
                                                const receivedAmount = event.target.value;
                                                const remainingAmount = (parseFloat(amounts.total_amount || "0") - parseFloat(receivedAmount || "0")).toFixed(2).toString();
                                                setAmounts({ ...amounts, received_amount: receivedAmount, remaining_amount: remainingAmount });
                                            }} />
                                        <MDInput label="Remaining Amount" style={{ flex: 1, width: "100%", margin: 10 }} disabled
                                            value={amounts.remaining_amount}
                                            onChange={(event) => {
                                                setAmounts({ ...amounts, remaining_amount: event.target.value });
                                            }} />
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"
                                        style={{ marginTop: 10 }}
                                    >
                                        <Box
                                            flex="1"
                                            display={"flex"}
                                            height={"100%"}
                                        >
                                            <FormControl sx={{ flex: "1", width: "100%" }}>
                                                <InputLabel id="demo-simple-select-label" style={{ marginLeft: 10, marginRight: 10 }}>Payment Mode</InputLabel>
                                                <Select
                                                    value={amounts.mode}
                                                    // IconComponent={() => { return (<ArrowDropDown />) }}
                                                    style={{ height: "1.4375em", padding: 20, marginLeft: 10, marginRight: 10 }}
                                                    onChange={(event) => {
                                                        console.log(event.target.value);
                                                        setAmounts({ ...amounts, mode: event.target.value });
                                                    }}
                                                    displayEmpty
                                                    label={"Payment Mode"}
                                                    inputProps={{ 'aria-label': 'Without label' }}
                                                >
                                                    {paymentModes.map((mode) => (
                                                        <MenuItem key={mode._id} value={mode._id}>{mode.name}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>
                                        </Box>
                                        <Box
                                            flex="1"
                                            display={"flex"}
                                            height={"100%"}
                                        >
                                            <FormControl sx={{ flex: "1", width: "100%" }}>
                                                <InputLabel id="receiving-account-select-label" style={{ marginLeft: 10, marginRight: 10 }}>Receiving Account</InputLabel>
                                                <Select
                                                    value={amounts.receiving_account}
                                                    style={{ height: "1.4375em", padding: 20, marginLeft: 10, marginRight: 10 }}
                                                    onChange={(event) => {
                                                        setAmounts({ ...amounts, receiving_account: event.target.value });
                                                    }}
                                                    displayEmpty
                                                    label={"Receiving Account"}
                                                    inputProps={{ 'aria-label': 'Without label' }}
                                                >
                                                    {receivingAccounts.map((account) => (
                                                        <MenuItem key={account._id} value={account._id}>{account.name}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        <Box
                                            flex="1"
                                            display={"flex"}
                                            height={"100%"}
                                        >
                                            <FormControl sx={{ flex: "1", width: "100%" }}>
                                                <InputLabel id="demo-simple-select-label" style={{ marginLeft: 10, marginRight: 10 }}>Payment Status</InputLabel>
                                                <Select
                                                    value={amounts.status}
                                                    // IconComponent={() => { return (<ArrowDropDown />) }}
                                                    style={{ height: "1.4375em", padding: 20, marginLeft: 10, marginRight: 10 }}
                                                    onChange={(event) => {
                                                        console.log(event.target.value);
                                                        setAmounts({ ...amounts, status: event.target.value });
                                                    }}
                                                    displayEmpty
                                                    label={"Payment Status"}
                                                    inputProps={{ 'aria-label': 'Without label' }}
                                                >
                                                    <MenuItem value={0}>Paid</MenuItem>
                                                    <MenuItem value={1}>Pending</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </MDBox>
                                    <MDBox
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-around"

                                    >
                                        <MDButton variant="outlined" color="error" style={{ flex: 1, margin: 10 }}
                                            disabled={load} onClick={() => {
                                                navigate('/packages');
                                            }}>Cancel</MDButton>
                                        <MDButton variant="outlined" color="success" style={{ flex: 1, margin: 10 }}
                                            disabled={load}
                                            onClick={() => {
                                                saveDetails();


                                            }}>{((location.state) && ("id" in location.state)) ? "Update" : "Create"}</MDButton>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </div>

                    </Grid>
                </Grid>
                {renderSB}
            </MDBox>
        </DashboardLayout>
    );
}

export default NewPackages;
